<template lang="pug">
  div
    .auth--privacy
      .text--center

        h1 {{ $t('privacy.title') }}

        p {{ $t('privacy.body', { app: appName }) }}

        p
          | {{ $t('privacy.linkto') }}
          a.link(:href="certPrivacy" target="_blank") {{ $t('privacy.link') }}
          | .
</template>

<script>
import { PROYECT } from "@/constant";

export default {
  data() {
    return {
      certPrivacy: null
    };
  },
  methods: {
    getCertPrivacy(lang) {
      const language = lang.toUpperCase();
      return PROYECT.APP.PRIVACY[language] || PROYECT.APP.PRIVACY.EN;
    }
  },
  created() {
    if (PROYECT.HOST !== "dknUsa") {
      this.$router.push({ name: "home" });
    }

    let { lang } = this.$route.params || "en";

    if (lang !== "en" && lang !== "es" && lang !== "fr") {
      lang = "en";
    }

    this.$i18n.locale = lang;
    this.certPrivacy = this.getCertPrivacy(lang);
  }
};
</script>
